import React, { useContext } from "react";
import "./homediscover.css";
import { FaInstagram } from "react-icons/fa";
import { SlSocialFacebook } from "react-icons/sl";
import oneday from "../photos/oneday.png";
import { TbPhoneCall } from "react-icons/tb";
import { HiOutlineMail } from "react-icons/hi";
import { NavLink } from "react-router-dom";
import { LanguageContext } from "../settings/LanguageContext"; // adjust path if needed
import { booktour } from "../tours/tours"; // import the booktour array
import { PiTiktokLogo } from "react-icons/pi";



const Homediscover = () => {
  const { lang } = useContext(LanguageContext); // get global language
  const garniId = booktour.find(t => t.id === "garni")?.id;

  return (
    <div className="main">
      <div className="main-discover">
        <div className="discover">
          <div className="sec1">
            <h1 className="title">
              {lang === "EN" ? "Discover Armenia" : "Откройте Армению"}
            </h1>
            <p className="text">
  {lang === "EN" ? (
    <>
      Explore ancient monasteries, stunning landscapes, and rich culture with <br />
       our expertly guided tours across Armenia
    </>
  ) : (
    <>
      Исследуйте древние монастыри, потрясающие пейзажи, и богатую культуру<br />
       с нашими опытными гидами по Армении
    </>
  )}
</p>
                <NavLink to={`/tour/${garniId}`}>
            <button className="btn-book">
              {lang === "EN" ? "Check Offer" : "Проверить предложение"}
            </button>
            </NavLink>

            <div className="icons">
              <a
                href="https://www.instagram.com/memory_maker_travel_armenia/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/ToursinArmeniaTourGuideinArmenia"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SlSocialFacebook className="fbicon" />
              </a>

              <a
                href="https://www.tiktok.com/@memory_maker_armenia?_r=1&_t=ZS-93yW6Hm1EhD"
                target="_blank"
                rel="noopener noreferrer"
              >
                <PiTiktokLogo  className="fbicon" />
              </a>

            </div>
          </div>
            <NavLink to={`/tour/${garniId}`}>
          <div className="sec2">
            <img src={oneday} alt="one day" />
            <h1 className="tit-oneday">
              {lang === "EN" ? "Special offer" : "Специальное предложение"}
            </h1>
            <h2 className="tit-bestday">
              {lang === "EN" ? "Don't miss the chance" : "Не упустите шанс"}
            </h2>
          </div>
            </NavLink>
        </div>
      </div>

      <div className="discover-bottom-buttuns">
        <a href="https://wa.me/37493106810" target="_blank" rel="noopener noreferrer">
          <div className="discover-bottom-btn">
            <TbPhoneCall size={24} color="#2176FF" />
            {lang === "EN" ? " (+374)93106810" : " (+374)93106810"}
          </div>
        </a>

        <a href="mailto:info@memorymakerarmenia.com">
          <div className="discover-bottom-btn" id="unique-width400">
            <HiOutlineMail size={24} color="#2176FF" /> info@memorymakerarmenia.com
          </div>
        </a>

        <NavLink to="/contactus">
          <div className="discover-bottom-btn" id="onlthbl">
            {lang === "EN" ? "Get In Touch" : "Связаться с нами"}
          </div>
        </NavLink>
      </div>
    </div>
  );
};

export default Homediscover;